import { createI18n } from 'vue-i18n'
import type { I18nOptions } from 'vue-i18n'
import { appConfig } from '@/types/appConfig.type.ts';

type Locale = 'en' | 'fr'
type LocaleMessages = Record<string, unknown>
type TranslationModule = { default: LocaleMessages }
type MessageTree = Record<string, string>
type MessagesTree = Record<string, MessageTree | LocaleMessages>

function loadLocaleMessages(): Record<Locale, MessagesTree> {
  const localesModules = import.meta.glob<TranslationModule>('./locales/**/*.json', { eager: true })
  const messages = {} as Record<Locale, MessagesTree>

  for (const path in localesModules) {
    const match: RegExpMatchArray | null = path.match(/\.\/locales\/([a-zA-Z0-9-_]+)\/(.*)\.json$/)
    if (!match) continue

    const locale: Locale = match[1] as Locale
    const filePath: string = match[2]
    const namespaces: string[] = filePath.split('/')
    const fileContent: LocaleMessages = localesModules[path].default

    if (!messages[locale]) {
      messages[locale] = {}
    }

    let current = messages[locale]
    for (let index: number = 0; index < namespaces.length; index++) {
      const namespace = namespaces[index]

      if (index === namespaces.length - 1) {
        current[namespace] = fileContent
      } else {
        if (!current[namespace] || typeof current[namespace] !== 'object') {
          current[namespace] = {}
        }
        current = current[namespace] as MessagesTree
      }
    }
  }

  return messages
}

const i18nOptions: I18nOptions = {
  locale: appConfig.VITE_DEFAULT_LOCALE,
  fallbackLocale: appConfig.VITE_FALLBACK_LOCALE,
  messages: loadLocaleMessages()
}

export default createI18n(i18nOptions)
